import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../../Styles/style";

import Incognitomodemixer from "../../../../assets/images/Incognitomodemixer.png";
import { useTheme } from "@emotion/react";

const MainGrid = styled(Grid)`
  padding: 80px 0 30px;
  justify-content: center;
  text-align: LEFT;
`;
const GridImg = styled(Grid)`
  /* text-align-last: right; */
`;
const GridText = styled(Grid)`
  padding: 80px 0 0;
`;
const LearnBuutt = styled.a`
  border: 1px solid ${(props) => props.theme.textPrimary};
  color: ${(props) => props.theme.textPrimary};
  padding: 7px 20px;
  text-decoration: none;
`;
const MetAMskimg = styled.img`
  width: 100%;
  max-width: 350px;
`;

const S4_Stats = () => {
  const theme = useTheme();
  return (
    <div>
      <SectionWrapper bgcolor={theme.bgPrimary} p="4rem 0" id="features">
        <Container maxWidth="xl">
          <MainGrid container rowGap={2}>
            <GridImg
              item
              xs={12}
              md={5}
              data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <MetAMskimg src={Incognitomodemixer} />
            </GridImg>
            <GridText
              item
              xs={12}
              md={5}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <SectionHeading
               data-aos="zoom-in"
               data-aos-easing="ease-in"
               data-aos-delay="300"
               data-aos-offset="0"
               data-aos-duration="1000"
              >
                Mixer
              </SectionHeading>
              {/* <P
                p="5px 0 10px"
                m="0"
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-offset="0"
                data-aos-duration="500"
              >
                <b>
                  Private Transactions On Ethereum, Shibarium Network, BNB
                  Chain, Polygon And Avalanch C-Chain
                </b>
              </P> */}
              <P
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                The Mixer feature allows you to anonymously swap
                cryptocurrencies, making it nearly impossible to trace your
                transactions. Your financial privacy is our priority.
              </P>
              <LearnBuutt
                href="#"
                target="blank"
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Learn More
              </LearnBuutt>
            </GridText>
          </MainGrid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S4_Stats;
